{
  "name": "postpaid",
  "version": "2.2.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:dev": "ng build --configuration development",
    "watch": "ng build --watch --configuration development",
    "test": "vitest",
    "test:coverage": "vitest run --coverage"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.23",
    "@angular/common": "^21.2.23",
    "@angular/compiler": "^21.2.23",
    "@angular/core": "^21.2.23",
    "@angular/forms": "^21.2.23",
    "@angular/platform-browser": "^21.2.23",
    "@angular/platform-browser-dynamic": "^21.2.23",
    "@angular/router": "^21.2.23",
    "angular-google-tag-manager": "^1.13.0",
    "ci": "^2.3.0",
    "material-icons": "^1.13.12",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "^2.7.2",
    "@angular/build": "^21.2.24",
    "@angular/cli": "~21.2.24",
    "@angular/compiler-cli": "^21.2.23",
    "@vitest/coverage-v8": "^4.1.11",
    "autoprefixer": "^10.4.20",
    "jsdom": "^30.1.0",
    "postcss": "^8.4.49",
    "tailwindcss": "^3.4.14",
    "typescript": "~5.9.3",
    "vitest": "^4.1.11"
  }
}
